import React from 'react'
import { ConnectedSimpleTour } from 'components'
import steps from './steps'

const FiscalInfoModalTour = props => (
  <ConnectedSimpleTour
    steps={steps}
    disableKeyboardNavigation={[]}
    tracingTourName="fiscal-info-modal-tour"
    {...props}
  />
)

export default FiscalInfoModalTour
